/**
 * Resource Builder - Generate Refine resources array.
 *
 * Only system resources (dashboard, inbasket) are registered statically.
 * All entity item types are handled dynamically via the catch-all route
 * and createDefaultConfig() at runtime.
 */
import type { ResourceProps } from "@refinedev/core";
import { getIconElement } from "./iconRegistry";

export interface ResourceOptions {
  /** i18n translate function */
  t: (key: string) => string;
}

/**
 * Build system resources (dashboard, inbasket)
 * These are not dynamic and have special behavior
 */
export function buildSystemResources(
  options: ResourceOptions,
): ResourceProps[] {
  const { t } = options;

  return [
    {
      name: "dashboard",
      list: "/dashboard",
      meta: {
        label: t("navigation.dashboard"),
        icon: getIconElement("dashboard"),
        group: "system",
        order: 1,
      },
    },
    {
      name: "inbasket",
      list: "/inbasket",
      meta: {
        label: t("navigation.inbasket"),
        icon: getIconElement("inbox"),
        group: "system",
        order: 2,
      },
    },
  ];
}

/**
 * Build all Refine resources (system only).
 * Entity resources are discovered dynamically from Aras TOC menu.
 */
export function buildAllResources(options: ResourceOptions): ResourceProps[] {
  return buildSystemResources(options);
}
